<template>
  <conditional-display-modal
      :conditional-rule-options="conditionalRuleOptions"
      disallow-multiple-sets
      :hide-preview="hidePreview"
      @toggle-modal="emitHideModal"
      v-bind="{...$attrs, ...$props}"
  >
    <template #rule-options="{ rule }">
      <button type="button" @click="() => deleteRule(rule)" class="btn-icon grey sm" :disabled="preventDelete" :style="preventDelete ? 'display: none' : null">
        <span class="sr-only">Delete Item</span>
        <icon class="times"></icon>
      </button>
    </template>
  </conditional-display-modal>
</template>

<script lang="ts">
import Vue from 'vue';
import ModalComponentMixin from "~/mixins/modalComponentMixin";
import ConditionalDisplayModalWrapperMixin from "~/mixins/conditional-display-modal-wrapper-mixin";
import ConditionalDisplayModal from "~/components/conditionalRuleBuilder/conditionalDisplayModal.vue";

export default Vue.extend({
  inheritAttrs: false,
  mixins: [
    ModalComponentMixin,
    ConditionalDisplayModalWrapperMixin,
  ],
  components: {
    ConditionalDisplayModal,
  },
  props: {
    hidePreview: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    preventDelete(): boolean {
      return Object.keys(this.ruleSet.conditional_rules).length < 2;
    },
  },
  methods: {
    deleteRule(deletedRule): void {
      deletedRule.delete();
      this.ruleSet.conditionalRules.forEach(rule => {
        if (rule.sort_order > deletedRule.sort_order) rule.sort_order--;
      });
    },
  },
});
</script>